import api from "api"

const eventSettings = {
    // Configurações avançadas do evento: check-in, transferência e presença.
    get: (slug) => {
        return api().get(`/events/detail/${slug}/settings`);
    },
    update: (slug, payload) => {
        return api().put(`/events/detail/${slug}/settings`, payload);
    },
}

export default eventSettings;
